import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "types/store";
import styles from "./style.module.css";
import { Button } from "aible";
import { LineInput } from "components/Inputs/LineInput";
import LabeledToggle from "components/Inputs/Toggle/Toggle";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as globalReducer from "containers/App/reducer";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";
const BlueprintSave = ({ showModal, blueprintName, children, ...retProps } = {}) => {
    const dispatch = useDispatch();
    const [bpShowModal, updateBpShowModal] = useState(showModal);
    const saveBlueprint = (name, description, saveLineageOverride) => dispatch(chatGPTReducer.saveBlueprint(name, description, undefined, saveLineageOverride));
    const isBlueprintCreating = useSelector((state) => globalReducer.getIsBlueprintCreating(state));
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { onClick: () => {
                updateBpShowModal(true);
            }, isLoading: isBlueprintCreating, type: "secondary", ...retProps }, children ?? "Save New"),
        React.createElement(SaveBlueprintModal, { saveBlueprint: saveBlueprint, showModal: bpShowModal, updateShowModal: (val) => updateBpShowModal(val), blueprintName: blueprintName })));
};
const SaveBlueprintModal = ({ updateShowModal, showModal, saveBlueprint, blueprintName }) => {
    const [bpName, updateBpName] = useState(blueprintName ?? "New Agent Template");
    const [bpDescription, updateBpDescription] = useState();
    const [saveLineage, updateSaveLineage] = useState(true);
    useEffect(() => {
        updateBpName(blueprintName ?? "New Agent Template");
    }, [blueprintName]);
    return (React.createElement(Dialog, { open: showModal, onOpenChange: () => updateShowModal(false) },
        React.createElement(DialogContent, null,
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, "Save Agent Template")),
            React.createElement("div", null,
                React.createElement("div", { className: styles.setting },
                    "Name",
                    React.createElement(LineInput, { value: bpName, onChange: (val) => updateBpName(val) }),
                    React.createElement("div", { className: styles.settingLabel }, "Description"),
                    React.createElement("textarea", { className: styles.settingPrompt, value: bpDescription, onChange: (val) => updateBpDescription(val.target.value) })),
                React.createElement("div", { className: styles.settingFlex },
                    React.createElement("div", { className: styles.settingLabel }, "Automatically apply updates from parent agent templates (Include in lineage)"),
                    React.createElement(LabeledToggle, { style: { display: "block" }, checked: saveLineage, onChange: () => {
                            updateSaveLineage(!saveLineage);
                        }, isAibleColors: true }))),
            React.createElement(DialogFooter, null,
                React.createElement(Button, { type: "secondary", onClick: () => updateShowModal(false), style: { marginRight: "auto" } }, "Close"),
                React.createElement(Button, { type: "primary", onClick: () => {
                        updateBpDescription(undefined);
                        updateShowModal(false);
                        updateSaveLineage(true);
                        return saveBlueprint(bpName, bpDescription, saveLineage ? undefined : false);
                    } }, "Save")))));
};
export default BlueprintSave;
